var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pictures"},_vm._l((_vm.pictures),function(picture){return _c('ArtistPictureManager',{key:picture.id_foto_artista,attrs:{"picture":picture}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }